import { Component, input, output, viewChild } from '@angular/core';
import { GaBadgeComponent, GaTooltipDirective, GaTooltipModule } from '@vsn-ux/ngx-gaia';

import { FeatureHighlightConfig } from './feature-highlight.model';

@Component({
  selector: 'di-feature-highlight-badge',
  templateUrl: './feature-highlight-badge.component.html',
  imports: [GaBadgeComponent, GaTooltipModule],
  host: {
    class: 'tw:absolute tw:inset-0 tw:z-1 tw:cursor-pointer',
    '(click)': 'onOverlayClick($event)',
  },
})
export class FeatureHighlightBadgeComponent {
  readonly config = input.required<FeatureHighlightConfig>();
  readonly dismissed = output<void>();

  private readonly tooltipSignal = viewChild<GaTooltipDirective>('tooltip');

  protected onOverlayClick(event: Event): void {
    event.stopPropagation();
    this.tooltipSignal()?.toggle();
  }

  protected onDismiss(): void {
    this.tooltipSignal()?.hide();
    this.dismissed.emit();
  }
}
